import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Explore from "@/pages/Explore";
import ListingDetail from "@/pages/ListingDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import TravelerDashboard from "@/pages/TravelerDashboard";
import HostDashboard from "@/pages/HostDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Messages from "@/pages/Messages";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Shop from "@/pages/Shop";
import ChangePassword from "@/pages/ChangePassword";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Region from "@/pages/Region";
import Notifications from "@/pages/Notifications";
import QuickAccess from "@/pages/QuickAccess";
import { UpdateBanner } from "@/components/Pwa";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

function AppRoutes() {
  const location = useLocation();
  const { user } = useAuth();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  if (user?.must_change_password && location.pathname !== "/changer-mot-de-passe") {
    return <Navigate to="/changer-mot-de-passe" replace />;
  }
  return (
    <Routes>
      <Route path="/changer-mot-de-passe" element={<ChangePassword />} />
      <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
      <Route path="/reinitialiser" element={<ResetPassword />} />
      <Route path="/" element={<Explore />} />
      <Route path="/logement/:id" element={<ListingDetail />} />
      <Route path="/connexion" element={<Login />} />
      <Route path="/acces-rapide" element={<QuickAccess />} />
      <Route path="/inscription" element={<Register />} />
      <Route path="/mes-sejours" element={<TravelerDashboard />} />
      <Route path="/espace-hote" element={<HostDashboard />} />
      <Route path="/administration" element={<AdminDashboard />} />
      <Route path="/messagerie" element={<Messages />} />
      <Route path="/courses" element={<Shop />} />
      <Route path="/region" element={<Region />} />
      <Route path="/mes-notifications" element={<Notifications />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
          <UpdateBanner />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
